import styled, { css } from 'styled-components';

export const AiWrapper = styled.div``;

export const ComponentWrapper = styled.div`
  ${({ $hidden }) => css`
    ${$hidden && css`
      max-height: 0;
      overflow: hidden;
    `}
  `}
`;
